export default "__VITE_ASSET__AUdOe$6B__"